<template>
  <div class="mt-2">
    <b-container>

      <div>
        <b-row class="form-group">
          <b-col md="6">
            <router-link to="/reports/comparative" class="back-button">
              <icon name="arrow-left" class="submenu-icon" scale="1.5" />
            </router-link>
          </b-col>
          <b-col md="6" align="right" class="d-flex justify-content-end">
            <b-button class="clear" @click="clearFilterData()">
              {{ $t("label_advancedData_clearFilters") }}
            </b-button>
            <b-button variant="primary" @click="setComparativeDataFromPromise()">
              {{ $t("label_advancedData_applyFilters") }}
            </b-button>
          </b-col>
        </b-row>
        <template-filters ref="filters" :multiple-years="true" />
        <b-row>
          <b-col cols="12" lg="12" md="12">
            <template-pillar-navigator-comparative
              :pillar-id="$route.params.pillar"
            />
          </b-col>
        </b-row>
        <!-- Pillar General Graph -->
        <b-row>
          <b-col cols="12" lg="12" md="12">
            <card-chart-compare
              v-if="getPillarIndex($route.params.pillar)"
              :key="randomKey"
              :key-value="'index'"
              :title="getPillarTitle()"
              :description="getPillarDescription($route.params.pillar)"
              :alias="$route.params.pillar"
              :chart-data="getPillarIndex($route.params.pillar)"
            />
            <div v-else align="center">
              <p class="card-text">
                {{ $t("no_data_label") }}
              </p>
            </div>
          </b-col>
        </b-row>
        <!-- End Pillar General Graph -->
        <!-- Pillars -->
        <b-row
          v-for="(chart, key) in getPillarData($route.params.pillar)"
          :key="key"
        >
          <b-col>
            <card-chart-compare-pillar
              v-if="chart.generalIndex"
              :title="getChartTitle(chart)"
              :description="chart.objective"
              :key="randomKey"
              :alias="key"
              :chart-data="chart.generalIndex"
              :ranges="chart.ranges"
              :ideals="chart.ideals"
            />
          </b-col>
        </b-row>
        <!-- End Pillars -->

        <!-- Conventions -->
        <template v-if="!$store.getters.getIsLoading">
          <b-row class="form-group">
            <b-col>
              <card-conventions
                :height="'auto'"
                :orientation="'horizontal'"
                :show-ideal="false"
                :show-company="false"
              />
            </b-col>
          </b-row>
        </template>
        <!-- End Conventions -->
      </div>
    </b-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "ReportsComparativePillar",
  components: {},
  data: function () {
    return {
      randomKey:'1'
    };
  },
  computed: mapGetters([
    "getComparativeData",
    "getPillarData",
    "getPillarIndex",
    "getPillarName",
    "getPillarDescription",
  ]),
  watch: {
    $route() {
      this.$route.params.pillar;
    },
    getComparativeData:{
      handler: function () {
        this.randomKey = Math.random().toString(36);
      }
    }
  },
  mounted() {
    this.setComparativeDataFromPromise();
  },
  methods: {
    getPillarTitle: function () {
      const PILLAR_DATA =
        this.getComparativeData.pillars[this.$route.params.pillar];
      return this.getChartTitle(PILLAR_DATA);
    },
    getChartTitle: function (chart) {
      if (chart.acronym) {
        return `${this.$t(chart.acronym)} - ${this.$t(chart.name)}`;
      }
      return this.$t(chart.name);
    },
    setComparativeDataFromPromise: function () {
      this.getComparativeDataPromise().then((comparativeData) => {
        comparativeData.generalIndex.map((gi) => {
          gi.businessName =
            this.$t(gi.businessName) +
            (gi.companyCounter ? " " + gi.companyCounter : "") +
            (gi.year ? ` (${gi.year})` : "");
          return gi;
        });

        Object.keys(comparativeData.pillars).map((pillar) => {
          comparativeData.pillars[pillar].generalIndex.map((gi) => {
            gi.businessName =
              this.$t(gi.businessName) +
              (gi.companyCounter ? " " + gi.companyCounter : "") +
              (gi.year ? ` (${gi.year})` : "");
            return gi;
          });
          Object.keys(comparativeData.pillars[pillar].children).map(
            (indicator) => {
              comparativeData.pillars[pillar].children[
                indicator
              ].generalIndex.map((gi) => {
                gi.businessName =
                  this.$t(gi.businessName) +
                  (gi.companyCounter ? " " + gi.companyCounter : "") +
                  (gi.year ? ` (${gi.year})` : "");
                return gi;
              });
            }
          );
        });

        var pillarsIds = Object.keys(comparativeData.pillars);
        this.$store.commit("setPillarsIds", pillarsIds);
        this.$store.commit("setComparativeData", comparativeData);
      });
    },
    clearFilterData() {
      if (this.$refs.filters) {
        this.$refs.filters.clearFilters();
      }
      this.setComparativeDataFromPromise();
    },
    getComparativeDataPromise() {
      let parameters = {
        Companies: [],
        Tags: [],
        Years: [],
        Types: [],
        Locations: [],
        Sizes: [],
        Activities: [],
      };
      if (this.$refs.filters) {
        parameters = this.$refs.filters.getDataInFilters();
      }
      return this.$store.dispatch("COMPAREPILLARS_REPORT", parameters);
    },
  },
};
</script>

<style lang="scss" scoped>
.clear{
  margin-right: 10px;
}
.back-button{
  color: #676767;
  border: 3px solid #676767;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 50px;
}
</style>
